// extracted by mini-css-extract-plugin
export default {"svg":"SpinningLogo_svg__zQnXJ","pipes":"SpinningLogo_pipes__g13af","rotate":"SpinningLogo_rotate__rByUd"};